require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-tags-j-kevin-ryan.json") })
        }
      }, "path---es-articles-tags-j-kevin-ryan");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-tags-j-kevin-ryan!./.cache/json/es-articles-tags-j-kevin-ryan.json
// module id = 2367
// module chunks = 231608221292675